module.exports = __webpack_public_path__ + "img/oufu_110x140x12b.prt.9a450a2c.jpg";